'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = require('redux-actions');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
  {
    type: 'cacheInput',
    payload: {
      key: 'itemNo',
      value: '001',
    }
  }
  */
var cacheInput = (0, _reduxActions.createAction)('cacheInput');
var actions = { cacheInput: cacheInput };

/**
  autofill: {
    itemNo: '001',
  }
  */
var reducer = (0, _reduxActions.handleAction)(cacheInput, function (state, _ref) {
  var _ref$payload = _ref.payload,
      key = _ref$payload.key,
      value = _ref$payload.value;
  return _extends({}, state, _defineProperty({}, key, value));
}, {});

exports.actions = actions;
exports.reducer = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/autofillOnFocus/autofill.js
// module id = 1115
// module chunks = 0